module.exports = __webpack_public_path__ + "static/media/bg_layer.6855ab4b.png";